import { Grid, Typography } from "@mui/material";
import { APP_VERSION } from "AppConstants";
import { Link } from "react-router-dom";

function Copyright() {
  const link = (
    <Link color="inherit" target="_blank" to="https://inoptra.com/">
      InOpTra
    </Link>
  );
  return (
      <Grid p={3} mt={3} container direction="row" justifyContent="space-between" alignItems="center">
        <Typography variant="body2" color="textSecondary">
          &copy; {new Date().getFullYear()} {link} - All Rights Reserved.
        </Typography>
        <Typography variant="body2" color="textSecondary">
          Timesheet v{APP_VERSION}
        </Typography>
      </Grid>
  );
}

export const Footer = () => {
  return (
    // <Typography variant="body2" color="textSecondary" align="center">
      <Copyright />
    // </Typography>
  );
};
